export const OPTION_TYPES = {
  CASH: 'cash',
  FEE: 'fee'
}

export const OPTIONS = [
  {id: OPTION_TYPES.CASH, label: 'COMMON_CASH'},
  {id: OPTION_TYPES.FEE, label: 'COMMON.FEE'}
]

export const LEGACY_OPTIONS = [
  {literal: 'COMMON_CASH', value: false},
  {literal: 'COMMON.FEE', value: true}
]

export const LEGACY_WRAPPER = 'legacy'
